import { render, staticRenderFns } from "./MobileLanding.vue?vue&type=template&id=6a22dd32&scoped=true"
import script from "./MobileLanding.vue?vue&type=script&lang=js"
export * from "./MobileLanding.vue?vue&type=script&lang=js"
import style0 from "./MobileLanding.vue?vue&type=style&index=0&id=6a22dd32&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22dd32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a22dd32')) {
      api.createRecord('6a22dd32', component.options)
    } else {
      api.reload('6a22dd32', component.options)
    }
    module.hot.accept("./MobileLanding.vue?vue&type=template&id=6a22dd32&scoped=true", function () {
      api.rerender('6a22dd32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/landing/MobileLanding.vue"
export default component.exports